import { createTheme, type ThemeOptions } from '@mui/material';
import { commonThemeBase as common } from '../common.theme.base';
import { componentOverrides } from './component.overrides';

const lightTableThemeBase = {
  ...common,

  palette: {
    mode: 'light',

    common: common.config.colors,

    text: {
      primary: common.config.colors.darkGrey3,
    },

    background: {
      default: common.config.colors.bbb,
      paper: common.config.colors.white,
      lighter: common.config.colors.eggWhite,
      tableHeader: common.config.colors.blueWhiteHard,
      tableRowHover: common.config.colors.paleGrey,
      tableRow: common.config.colors.white,
      tableBody: common.config.colors.bbb,
    },

    border: {
      menuItem: common.config.colors.black,
    },

    button: {
      disabledBackground: common.config.colors.grey6,
    },

    components: {
      globalHeader: {
        contrastText: common.config.colors.dark,
      },
    },

    error: {
      main: common.config.colors.error,
      dark: common.config.colors.ripeTomato,
    },

    graphs: {
      pie: {
        primary: common.config.colors.cowbellLight,
        secondary: common.config.colors.darkGreyLighter,
        primaryBlue: common.config.colors.cowbellLight,
        secondaryBlue: common.config.colors.powderBlue,
        primaryGreen: common.config.colors.cowbellAccent,
        secondaryGreen: common.config.colors.cowbellGreen,
      },
    },

    primary: {
      main: common.config.colors.cyan,
      green: common.config.colors.good,
      yellow: common.config.colors.elevated,
      red: common.config.colors.critical,
      grey: common.config.colors.greyWhite,
    },

    tables: {
      productRow: common.config.colors.tableRowLight,
    },

    jsonPalette: {
      base00: common.config.colors.eggWhite, // background
      base01: '#444',
      base02: common.config.colors.darkGreySoft,
      base03: common.config.colors.darkGreySoft,
      base04: common.config.colors.darkGreySoft,
      base05: '#444',
      base06: '#444',
      base07: common.config.colors.darkGreySoft,
      base08: '#444',
      base09: common.config.colors.darkGreySoft,
      base0A: common.config.colors.darkGreySoft,
      base0B: common.config.colors.darkGreySoft,
      base0C: common.config.colors.darkGreySoft,
      base0D: common.config.colors.darkGreySoft,
      base0E: common.config.colors.darkGreySoft,
      base0F: common.config.colors.darkGreySoft,
    },
  },
} as Partial<ThemeOptions>;

const themedComponentOverrides = componentOverrides(lightTableThemeBase);

export const lightTableTheme = createTheme({
  ...lightTableThemeBase,
  ...themedComponentOverrides,
});
